module.exports = __webpack_public_path__ + "static/heller1-80f29db5a0741ef76e82b0ddfdc319e1.jpg";